var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.866 18H18v-6H2v6h3.134A.995.995 0 0 1 5 17.5v-2.287a1 1 0 0 1 2 0V17.5a.995.995 0 0 1-.134.5h2.268A.995.995 0 0 1 9 17.5v-2.287a1 1 0 0 1 2 0V17.5a.995.995 0 0 1-.134.5h2.268a.995.995 0 0 1-.134-.5v-2.287a1 1 0 0 1 2 0V17.5a.995.995 0 0 1-.134.5zM13 9H2v1h16V9h-5zM7 7V3a3 3 0 1 1 6 0v4h5a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5zm2 0h2V3a1 1 0 0 0-2 0v4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaint);
export default __webpack_public_path__ + "static/media/icon-paint.11ca0797644b0c8edf10c749f64921ed.svg";
export { ForwardRef as ReactComponent };